import { render } from "./ImportPeriodComponent.vue?vue&type=template&id=08dada76"
import script from "./ImportPeriodComponent.vue?vue&type=script&lang=js"
export * from "./ImportPeriodComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/4schemplus/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__